import { DECIMAL_PRECISION, TIER_DEPOSITS, TIER_POLICY_REQUIREMENTS } from './foundation'

export {
  DECIMAL_PRECISION,
  TIER_DEPOSITS,
  TIER_POLICY_REQUIREMENTS,
}

/** Distribution weight per tier. Read only through `shared/rules/payoutRules.ts`. */
export const TIER_WEIGHTS = {
  trial: 5,
  bronze: 10,
  silver: 51,
  gold: 102,
} as const

/** Weight multiplier for a member who checked in this period. Read only through `shared/rules/payoutRules.ts`. */
export const SNAPSHOT_BOOST_MULTIPLIER = 1.2

export const VAULT_LIMITS = {
  MIN_DISTRIBUTION_AMOUNT: 0,
  MIN_ASSET_VALUE: 0,
} as const

export const ERROR_MESSAGES = {
  NO_YIELD_AVAILABLE: 'No yield available to distribute',
  NO_MEMBERS_FOUND: 'No members with wallet addresses found',
  AUTH_REQUIRED: 'Authentication required. Please sign in first.',
  COLLECT_REWARDS_FAILED: 'Failed to collect rewards',
  PREPARE_DISTRIBUTION_FAILED: 'Failed to prepare distribution',
  DISTRIBUTION_NOT_PREPARED: 'Distribution not prepared – nothing to download',
  DISTRIBUTION_PREPARE_FIRST: 'Please prepare the distribution first',
} as const
